<template>
  <div class="file-table-container">
    <div v-for="(record, index) in dataSource" :key="record.id || index" class="material-card">
      <!-- 第一行：材料清单名称和下载模板 -->
      <div class="material-card-row">
        <div class="material-name">
          <span class="index-number">{{ index + 1 }}.</span>
          {{ record.displayName || record.materialTemplateName }}
        </div>
        <div class="template-download">
          <a
              v-if="record.url || record.materialTemplateFile"
              style="color: #1e8ef2; margin-right: 16px; font-size: 14px;"
              :href="record.url || record.materialTemplateFile"
              target="_blank"
          >
            下载模板
          </a>
        </div>
      </div>

      <!-- 第二行：已上传文件信息和操作按钮 -->
      <div class="material-card-row">
        <!-- 已上传文件显示 -->
        <div class="uploaded-file" v-if="record.uploadFile || record.addUrl">
          <CheckCircleOutlined style="color: #52c41a; margin-right: 4px;" />
          已上传文件：
          <span class="file-name">
            {{ getFileName(record.uploadFile || record.addUrl) }}
          </span>
        </div>

        <!-- 材料上传/重新上传 -->
        <div class="upload-action">
          <uploadText
              :info="record"
              pathName="car"
              @uploadFinished="uploadFinished"
          >
            {{ record.uploadFile || record.addUrl ? '重新上传' : '材料上传' }}
          </uploadText>
        </div>

        <!-- 文件预览和下载 -->
        <div class="preview-download">
          <span
              class="action-btn"
              :style="{
              color: (record.uploadFile || record.addUrl) ? '#1e8ef2' : '#ccc',
              pointerEvents: (record.uploadFile || record.addUrl) ? 'auto' : 'none'
            }"
              @click="preview(record)"
          >
            预览
          </span>
          <span class="separator">|</span>
          <a
              class="action-btn"
              :style="{
              color: (record.uploadFile || record.addUrl) ? '#1e8ef2' : '#ccc',
              pointerEvents: (record.uploadFile || record.addUrl) ? 'auto' : 'none'
            }"
              :href="record.uploadFile || record.addUrl"
              target="_blank"
          >
            下载
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, onBeforeMount, defineProps, defineExpose } from "vue";
import uploadText from "@/components/uploadText/index.vue";
import { fileUpdateById } from "@/api/qualification/index";
import moment from "moment";
import { message } from "ant-design-vue";
import { Base64 } from "js-base64";
import { CheckCircleOutlined } from '@ant-design/icons-vue';

const props = defineProps({
  //测试类型
  type: {
    type: String,
    default: () => "0",
  },
  data: {
    type: Array,
    default: () => {
      return [];
    },
  },
  add: {
    type: Boolean,
    default: () => true,
  },
  //资质id,单个更新材料时使用
  id: {
    type: String,
    default: () => "",
  },
});

let dataSource = ref([]);

watch(
    () => props.type,
    (val) => {
      // getData(val)
    }
);

watch(
    () => props.data,
    (val) => {
      dataSource.value = val;
    },
    { immediate: true }
);

function uploadFinished(url, row) {
  let obj = {
    materialTemplateFile: row.url || row.materialTemplateFile,
    materialTemplateId: row.id,
    materialTemplateName: row.displayName || row.materialTemplateName,
    uploadFile: url,
    sort: row.sort,
  };
  if (props.add) {
    row.addUrl = url;
  }
  if (!props.add) {
    //编辑
    obj.id = row.id;
    obj.materialTemplateId = row.materialTemplateId;
  }
  if (props.id) {
    let time = moment().format("YYYY-MM-DD HH:mm:ss");
    let data = {
      ...obj,
      uploadTime: time,
    };
    fileUpdateById(data).then((res) => {
      if (res.code == 200) {
        message.success("上传成功");
      }
    });
  }
  dataSource.value.map((item) => {
    if (props.add) {
      if (item.id == obj.materialTemplateId) {
        item.uploadFile = obj.uploadFile;
      }
    } else {
      if (item.id == obj.id) {
        item.uploadFile = obj.uploadFile;
      }
    }
  });
}

const getFileName = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }

  let arr = url.split("/");
  let file = arr[arr.length - 1];

  // 如果文件名包含点号且不以点号开头，则截取掉后缀
  const dotIndex = file.lastIndexOf(".");
  if (dotIndex > 0) {
    return file.substring(0, dotIndex);
  }

  return file;
};


const preview = (record) => {
  let url = "";
  // 开发环境
  if (process.env.NODE_ENV == "development") {
    url = process.env.VUE_APP_PREVIEW_URL;
  } else if (process.env.NODE_ENV == "production") {
    url = 'http://192.168.74.107:8080' + "/file-online-preview" + "/onlinePreview?url=";
  }
  if (props.add) {
    // 新增 在线预览 跳转新页面
    window.open(url + encodeURIComponent(Base64.encode(record.addUrl)));
  } else {
    // 编辑 在线预览 跳转新页面
    window.open(url + encodeURIComponent(Base64.encode(record.uploadFile)));
  }
};

defineExpose({
  dataSource,
});
</script>

<style scoped>
.file-table-container {
  width: 100%;
}

.material-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #fff;
}

.material-card-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.material-card-row:last-child {
  margin-bottom: 0;
}

.material-name {
  flex: 1;
  font-weight: 450;
  font-size: 14px;
}

.index-number {
  display: inline-block;
  min-width: 24px;
  text-align: center;
  margin-right: 8px;
  color: #666;
}

.template-download {
  margin-left: auto;
}

.uploaded-file {
  flex: 1;
  font-size: 14px;
  color: #666;
}

.file-name {
  color: #1e8ef2;
  margin-left: 4px;
}

.file-size {
  color: #999;
  font-size: 12px;
  margin-left: 8px;
}

.upload-action {
  margin: 0 24px;
}

.preview-download {
  display: flex;
  align-items: center;
}

.action-btn {
  cursor: pointer;
  font-size: 14px;
  padding: 0 8px;
}

.separator {
  color: #e8e8e8;
  margin: 0 4px;
}
</style>